import usePartsColumns from '@/components/Operational/Inventory/Parts/usePartsColumns';
import {
  DetailsButton,
  EditIcon,
  Group,
  InfiniteTable,
} from '@/components/_common';
import { useStockItems } from '@/core/domain/stock/StockItems/StockItems.hooks';
import {
  ListStockItemsQuery,
  StockItem,
} from '@/core/domain/stock/StockItems/StockItems.types';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import { flatInfiniteResult } from '@/utils/request/flatInfiniteResult';
import { getTableScrollX } from '@/utils/table';
import { ColumnsType } from 'antd/lib/table';
import { Link } from 'react-router-dom';
import partsOrderColumns from '@/utils/functions/partsOrderColumns/partsOrderColumns';
import { Divider, Tag } from 'antd';

interface Props {
  translate: (message: string, type: 'column' | 'button') => string;
  params?: ListStockItemsQuery;
  setQueryParams: React.Dispatch<React.SetStateAction<ListStockItemsQuery>>;
}

export default function SearchPartsTable({
  translate,
  params,
  setQueryParams,
}: Props) {
  const { data, isFetching, fetchNextPage, hasNextPage } = useStockItems(true, {
    ...params,
  });

  const { columns, isFetching: isFetchingColumns } = usePartsColumns({
    hasSorter: true,
  });

  const replacementParts: ColumnsType<StockItem> =
    params?.isPartReplacement &&
    params &&
    Object.values(params)
      .map((value) => String(value))
      .filter((value) => !!value).length >= 6
      ? [
          {
            key: 'isPartReplacement',
            title: 'Substituta',
            render: (row: StockItem) =>
              row.isPartReplacement && <Tag color="blue">Substituta</Tag>,
            align: 'center',
            width: 90,
          },
        ]
      : [];

  const parts = flatInfiniteResult(data);
  const allColumns: ColumnsType<StockItem> = [
    ...columns,
    ...replacementParts,
    {
      key: 'action',
      title: 'Ação',
      width: 150,
      align: 'right',
      fixed: 'right',
      render: (row, item) => (
        <Group position="right">
          <Link to={`/app/searchParts/${row.partId}/stock`}>
            <DetailsButton>{translate('select', 'button')}</DetailsButton>
          </Link>

          <Divider type="vertical" />

          <EditIcon
            iconProps={{
              onClick: () =>
                window.open(
                  `/app/operational/inventory/parts/${item.partId}/general`,
                  '_blank',
                ),
            }}
            disabled={!hasPermissions([Authorities.REGISTER_PART_EDIT])}
          />
        </Group>
      ),
    },
  ];

  const handleColumns = hasPermissions([Authorities.REGISTER_PART_EDIT])
    ? allColumns
    : allColumns.filter((columns) => columns.key !== 'edit');

  return (
    <InfiniteTable
      loading={isFetching || isFetchingColumns}
      columns={handleColumns}
      onChange={(_p, _f, sorter) => {
        if (!Array.isArray(sorter)) {
          partsOrderColumns(sorter, setQueryParams);
        }
      }}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      dataSource={parts}
      rowKey={(row) => row.partId}
      scroll={{ x: getTableScrollX(columns) }}
      className="scroll-table"
    />
  );
}
